import styles from "./styles.module.css";
import { MdChevronRight } from "react-icons/md";
const sections = [
  {
    name: "General",
    link: "https://www.notion.so/brevity/c34054a42fe64ab5a55cc782ee1d5e46?v=53aaf0388f1c47afa51c6a9e51fd6371",
  },
  { name: "Plan/Billing", link: "" },
  { name: "Email", link: "" },
  { name: "Editors", link: "" },
];
export default function Sidebar({ selected, setSelected }) {
  return (
    <div className={styles.sidebar}>
      {sections.map((s) => {
        return (
          <div
            className={
              selected.name === s.name
                ? styles.item + " " + styles.active
                : styles.item
            }
            key={s.name}
            onClick={() => setSelected(s)}
          >
            <div> {s.name}</div>
            <MdChevronRight className={styles.arrowIcon} />
          </div>
        );
      })}
    </div>
  );
}
